import { SettingListSchema, type Setting } from "@/types/Settings";

export const isSendApprovalRequest = async (): Promise<boolean> => {
  let allow = false;
  await axios
    .get("/settings/send-approval-request")
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          allow = data;
        },
        (errors: ApiError[]) => {
          error("An error occurred", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));
  return allow;
};

export const getSystemSettings = async (): Promise<Setting[]> => {
  let settings: Setting[] = [];

  await axios
    .get("/settings/system")
    .then((response) => {
      handleApiResponse(
        response,
        (data: any) => {
          settings = SettingListSchema.parse(data);
        },
        (errors: ApiError[]) => {
          error("An error occurred", errors[0].message);
        }
      );
    })
    .catch((e) => errorApi(e));

  return settings;
};

export const updateSetting = (setting: string, value: string): void => {
  let data = new FormData();
  data.append("name", setting);
  data.append("value", value);

  axios
    .post("/settings/update", data)
    .then((response) => {
      success("Success", "Setting updated");
    })
    .catch((e) => errorApi(e));
};
